<template>
    <div class="test-vue">
        <button @click="count++">{{ count }}</button>
    </div>
</template>
<script type="text/babel">
    export default {
        name: 'test-vue',
        data() {
            return {
                count: 0
            }
        }
    }
</script>

<style>
    .test-vue {
        position: relative;
    }
    .test-vue > button {
        position: fixed;
        left: 0;
        top: 400px;
        z-index: 1000;
    }
</style>